<div class="collapsibleTitle pageTitle">
  <div
    class="collapseButtonContainer"
    *appPermsRoles="[roles.RHOMOLOG, roles.REVISOR, roles.ADMIN]"
  >
    <button
      type="button"
      *ngIf="opened"
      class="submitSearchButton"
      (click)="onOpen()"
    >
      <em class="fas fa-angle-up"></em>
    </button>
    <button
      type="button"
      *ngIf="!opened"
      class="submitSearchButton"
      (click)="onOpen()"
    >
      <em class="fas fa-angle-down"></em>
    </button>
    <div class="pageTitle collapsibleTitle">
      <div class="title halfTitle">Reasignación de analista</div>
    </div>
  </div>
</div>

<div *ngIf="opened" class="contenedor">
  <p>
    La solicitud esta actualmente asignada al analista
    <strong>{{ analyst }}</strong>
  </p>

  <form (ngSubmit)="onSelect()" class="wrapper">
    <div class="firstPart">
      <label id="analista">Seleccione otro analista si lo desea</label>
    </div>
    <div class="secondPart">
      <app-input-selector-with-search
        #inputWithSearch
        [list]="analystList.list"
        [fields]="['usuarioId', 'nombre']"
        [id]="'usuarioId'"
        [item]=""
        (sendValue)="valueSelector($event)"
      ></app-input-selector-with-search>
    </div>
    <div class="firstPart hideBackground"></div>
    <div class="secondPart">
      <div class="compareButton">
        <button class="formButton" type="submit">
          {{ "commons.ok" | translate }}
        </button>
      </div>
    </div>
  </form>
</div>
